import React, {Component} from 'react'
import {connect} from 'react-redux'
import {createResource, deleteResource, getResource, updateResource} from '../../../data/actions/resource'
import LocalStorage from '../../../util/localStorage'
import Resources from '../../../data/services/resources'
import {showModal} from '../../../data/actions/ui'
import {
    checkPerm,
    classNames,
    getDefaultTableOptions,
    getDefaultTableOptionsJSON,
    getLookup,
    getProp,
    mergeDeep,
    resourceIsCreated,
    returnOffsetAndPagination,
    saveTableColumns,
} from '../../../common/util/util-helpers'
import {Field, FieldsManager} from '../../../data/services/fields'
import {download} from '../../../data/actions/download'
import PageHeader from "../../../common/components/layout/layout-components/page/page-header";
import ActiveFilters from "../../../common/components/resource-table/table-components/active-filters";
import Tippy from '@tippyjs/react'
import DocumentArrowDownIcon from '@heroicons/react/20/solid/DocumentArrowDownIcon'
import NoRecordsTable from "../../../common/components/no-records-found/no-records-table";
import ModalConfirm from "../../../common/components/modal/modal-confirm";
import {CREATE_PERM, DEFAULT_CRUD_STATE, DELETE_PERM, READ_PERM, UPDATE_PERM} from '../../../util/util-constants'
import {currentDate, timeZoneToUTC, toFrontDateTimeFromUTC} from '../../../common/util/util-dates'
import PageHeaderInfo from "../../../common/components/layout/layout-components/page/page-header-info";
import Pagination from "../../../common/components/resource-table/table-components/pagination";
import CellButtonWithCopy from "../../../common/components/resource-table/table-components/cell-button-copy";
import Page from "../../../common/components/layout/layout-components/page";
import TableSettingsPopOver from "../../../common/components/resource-table/table-components/table-settings-popover";
import TableOptionsDialog from "../../../common/components/resource-table/table-components/table-options-dialog";
import Layout from "../../../common/components/layout";
import TableCard from "../../../common/components/resource-table/table-components/table-card";
import TableFilters from "../../../common/components/resource-table/table-components/table-filters";
import ResourceTable from "../../../common/components/resource-table";
import TableCardFooter from "../../../common/components/resource-table/table-components/table-card-footer";
import {DEFAULT_QUERY_LIMIT} from "../../../common/util/util-consts";
import Button from "../../../common/components/button";
import {resetDialogResource} from "../../../data/actions/dialogResource";
import FmcsaImportDialog from "../carriers-view/fmcsa-import-dialog";
import {getUser} from "../../../common/util/util-auth";
import CompanyExceptions from "../../../common/util/util-exceptions";
import ModalHeader from "../../../common/components/modal/modal-header";
import CreateSuccessModal from "../../../common/components/modal/create-success-modal";
import {Bars4Icon, DocumentTextIcon, PresentationChartBarIcon} from "@heroicons/react/24/outline";
import {ArrowTopRightOnSquareIcon} from "@heroicons/react/20/solid";
import Modal from "../../../common/components/modal";
import ModalSaveResource from "../../../common/components/modal/modal-save-resource";
import ReminderList, {ReminderCell} from "../../../common/components/reminder-list";
import CandidateChecklistProgress from "../../personnel/components/candidate-checklist-progress";
import {fillFieldsFromData} from "../../../common/util/util-fields";

class Customers extends Component {
    constructor(props) {
        super(props)
        this.pagePath = this.props.location.pathname.substring(1)

        this.tablePageDefaults = {
            behaviour: {
                rowSelect: true,
                canAdjustWidth: true,
                hasMenu: true
            },
            style: {
                condensed: true,
                isGPUAccelerated: true
            },
            columns: {
                Reminders: {show: false},
                Progress: {show: false}
            }
        }

        this.state = {
            // Defaults and filters
            ...DEFAULT_CRUD_STATE,
            sortBy: 'LegalName',
            fields: this.getFields(),
            tableOptions: getDefaultTableOptions(this.getFields(), this.tablePageDefaults, this.pagePath, this.props.translate),
            queryFilterFields: this.getQueryFilterFields(),
            prefilled: '',
            isColumnsDialogVisible: false,

            // Dialogs
            confirmDialog: false,
            confirmDialogHideAnimation: false,
            breakpoint: {},
            isTableFullScreen: false,

            // Reminder
            reminderItem: null,
            isReminderModalOpen: false,
            isReminderSaving: false,
            isReminderEditSaving: false,
            reminderDeleteItem: null,
        }

        this.importedCustomerID = "";
        this.OrganizationID = "";

        this.state = mergeDeep(this.state, LocalStorage.rehydrateState(this.pagePath))
        this.states = getLookup('State', 'StateID', "StateAbbreviation") ?? {};
    }

    /** Lifecycle
     ================================================================= */
    componentDidMount() {
        this.fetchData()
    }

    componentDidUpdate(prevProps) {
        if (resourceIsCreated(this.props.resource, prevProps.resource, "CustomerID")) {
            this.importedCustomerID = this.props.resource.create.CustomerID;
            this.OrganizationID = this.props.resource.create.OrganizationID;

            this.toggleCreateSuccessDialog();
        }
    }

    /** Data Events
     ================================================================= */
    fetchData = () => {
        this.props.dispatch(getResource({
            user: LocalStorage.get('user'),
            resource: this.getResource(),
            query: this.getQuery()
        }))
    }

    downloadExcel = () => {
        this.props.dispatch(download({
            user: LocalStorage.get('user'),
            resource: this.getResource(),
            query: Object.assign({format: 'EXCEL', name: 'customers_' + currentDate() + '.xlsx'}, this.getQuery())
        }))
    }

    downloadExcelTemplate = () => {
        this.props.dispatch(download({
            user: LocalStorage.get('user'),
            resource: this.getResource(),
            query: Object.assign({
                format: 'EXCEL',
                name: 'customers_template' + currentDate() + '.xlsx'
            }, this.getQuery(), {excelTemplate: 1})
        }))
    }

    archiveResource = (item) => {
        this.setState({text: `${this.props.translate('message.confirm_archive_generic')} ${item.LegalName}?`}, () => {
            this.handleToggleConfirmDialog(() => {
                this.setState({
                    ...returnOffsetAndPagination(getProp(this.props.resource.data, 'list', []), this.getQuery(), this.state.paginationPage),
                    confirmDialog: false
                }, () => {
                    this.props.dispatch(deleteResource({
                        user: LocalStorage.get('user'),
                        query: Object.assign({}, {id: item.CustomerID}),
                        piggyQuery: this.getQuery(),
                        errorMessage: true,
                        successMessage: this.props.translate(`message.archived_generic`, [item.LegalName]),
                        resource: this.getResource(),
                        piggyResource: this.getResource()
                    }))
                })
            }, item)
        })
    }

    restoreFromArchive = (item) => {
        this.setState({text: `${this.props.translate('message.confirm_restore_generic')} ${item.LegalName}?`}, () => {
            this.handleToggleConfirmDialog(() => {
                this.setState({confirmDialog: false}, () => {
                    this.props.dispatch(updateResource({
                        user: LocalStorage.get('user'),
                        params: {
                            id: item.CustomerID,
                            ArchivedDate: 1
                        },
                        query: this.getQuery(),
                        errorMessage: true, successMessage: `Customer ${item.LegalName} restored successfully`,
                        resource: this.getResource(),
                        piggyResource: this.getResource()
                    }))
                })
            }, item)
        })
    }

    importFromFMCSA = (data) => {
        const params = {
            "CountryID": 1,
            "LegalName": data["legalName"],
            "DBAName": data["dbaName"],
            "AddressName": data["phyStreet"],
            "AddressName2": "",
            "CityName": data["phyCity"],
            "StateID": Object.keys(this.states).find(stateKey => this.states[stateKey] === data["phyState"]),
            "PostalCode": data["phyZipcode"],
            "ContactGroupID": getUser('ContactGroups')?.[0]?.ContactGroupID,
            "UserDefinedField1": "",
            "UserDefinedField2": "",
            "AreaCode": "+1",
            "PhoneNumber": '',
            "PhoneExtension": '',
            "PrimaryEmail": '',
            "SCAC": "",
            "OrganizationEntityTypeID": "",
            "MCNumber": data["docketNumber"] ?? data['MCNumber'],
            "USDOTNumber": data["dotNumber"],
            "FederalID": data['ein'],
            "NaicsID": "",
            "SendPromotionalEmails": 1,
            "Notes": '',
            "ContractOnFile": 0,
            "ContractStartDate": "",
            "ContractEndDate": "",
            "ContactNumber": "",
            "Blacklisted": 0,
            "Preferred": 0,
            "NumOfTrucks": data["totalPowerUnits"] ?? 0,
            "NumOfTrailers": "",
            "LiabilityInsuranceNo": "",
            "LiabilityInsuranceExpiryDate": "",
            "LiabilityInsuranceAmount": "",
            "CargoInsuranceNo": "",
            "CargoInsuranceExpiryDate": "",
            "CargoInsuranceAmount": "",
            "TrailerInteropInsuranceNo": "",
            "TrailerInteropInsuranceExpiryDate": "",
            "WorkCompInsuranceNo": "",
            "WorkCompInsuranceExpiryDate": "",
            "IsBrokerAuth": data?.brokerAuthorityStatus === "A" ? 1 : 0,
            "IsCommonAuth": data?.commonAuthorityStatus === "A" ? 1 : 0,
            "IsContractAuth": data?.contractAuthorityStatus === "A" ? 1 : 0,
            "Reviews": [],
            "Contacts": []
        }

        this.props.dispatch(createResource({
            user: LocalStorage.get('user'),
            params: params,
            resource: Resources.Customers,
            piggyResource: Resources.Customers,
            query: this.getQuery(),
            errorMessage: true
        }));
        this.handleCloseImportFMCSAClick();
    }

    handleImportFMCSAClick = () => {
        this.setState({
            isImportFMCSADialogVisible: true
        }, () => {
            this.props.dispatch(resetDialogResource());
        })
    }

    handleCloseImportFMCSAClick = () => {
        this.setState({
            isImportFMCSADialogVisible: false
        }, () => {
            resetDialogResource();
        })
    }

    /** UI Events
     ================================================================= */
    handleBreakpointChange = (breakpoint) => {
        this.setState({
            breakpoint
        }, () => {
            if (this.state.breakpoint.index <= 1 && this.state.queryFilterFields.limit.value !== 10) {
                this.handleFilterInputChange('limit', 10);
            }
        });
    }

    handleToggleConfirmDialog = (submit) => {
        this.setState({
            confirmModal: submit,
            confirmDialog: !this.state.confirmDialog
        })
    }

    handleShowDetails = (item) => {
        this.props.dispatch(showModal('ViewCustomerCard', item))
    }

    handleUpdateOffset = (offset, num) => {
        this.setState({
            offset: offset,
            paginationPage: num
        }, () => {
            this.saveFilters()
            this.fetchData()
        })
    }

    handleUpdateSort = (sortBy) => {
        let sort = (this.state.sortBy === sortBy) ? (this.state.sort === 'ASC' ? 'DESC' : 'ASC') : 'ASC'
        if (!sortBy) {
            sortBy = 'LegalName'
        }
        this.setState({
            sortBy: sortBy,
            sort: sort
        }, () => {
            this.saveFilters()
            this.fetchData()
        })
    }

    handleFilterInputChange = (name, value) => {
        this.setState({
            queryFilterFields: FieldsManager.updateField(this.state.queryFilterFields, name, value),
            offset: 0,
            paginationPage: 1
        }, () => {
            this.saveFilters()
            this.fetchData()
        })
    }

    handleClearFiltersClick = (excludeAdditional = []) => {
        const queryFilterFields = Object.assign({}, this.state.queryFilterFields)
        const defaultExcludedFields = ['limit']
        const excludedFields = defaultExcludedFields.concat(excludeAdditional)

        Object.values(queryFilterFields).filter(it => !excludedFields.includes(it.name)).forEach(it => {
            FieldsManager.updateField(queryFilterFields, it.name, '')
        })

        this.setState({
            queryFilterFields: queryFilterFields,
            offset: 0,
            paginationPage: 1
        }, () => {
            this.saveFilters()
            this.fetchData()
        })
    }

    handleCreateUpdateResource = (item = null) => {
        if (item) {
            this.handleLinkClick(`/customers/info/${item.OrganizationID}/${item.CustomerID}`)
        } else {
            this.handleLinkClick(`/customer/create?prefilled=` + this.state.prefilled)
        }
    }

    handleLinkClick = (link) => {
        this.props.history.push(link)
    }

    handleSetTableColumnOptions = (columns) => {
        let tableOptions = Object.assign({}, this.state.tableOptions)

        tableOptions.columns = columns.reduce((memo, it) => {
            memo[it.name] = it
            return memo
        }, {})

        this.setState({
            tableOptions,
            isColumnsDialogVisible: false
        }, () => saveTableColumns(this.pagePath, tableOptions))
    }

    getDefaultTableColumnOptions = () => {
        return getDefaultTableOptionsJSON(this.getFields(), {}, this.props.translate);
    }

    handleToggleColumnSettingsDialog = () => {
        this.setState({
            isColumnsDialogVisible: !this.state.isColumnsDialogVisible
        })
    }

    setOptions = (options) => {
        this.setState({
            tableOptions: options
        }, () => saveTableColumns(this.pagePath, options))
    }

    handleFullScreenToggle = () => {
        this.setState({
            isTableFullScreen: !this.state.isTableFullScreen
        })
    }

    /** Helpers
     ================================================================= */
    getQuery = () => {
        return {
            sort: this.state.sort,
            sortBy: this.state.sortBy,
            offset: this.state.offset,
            ...FieldsManager.getFieldKeyValues(this.state.queryFilterFields),
            searchFields: JSON.stringify({
                CreditHold: this.state.queryFilterFields?.CreditHold?.value ? "1" : undefined
            })
        }
    }

    getQueryFilterFields = () => {
        return {
            query: new Field('query', '', [''], false, 'search', {}, {}),
            StateID: new Field('StateID', '', [], false, 'select', {}, {isClearable: true}),
            ContactGroupID: new Field('ContactGroupID', '', [], false, 'select-search', {}, {isClearable: true}),
            OfficeID: new Field('OfficeID', '', [], false, 'select-search', {}, {isClearable: true}),
            OrganizationEntityTypeID: new Field('OrganizationEntityTypeID', '', [], false, 'select', {}, {isClearable: true}),
            CreditHold: new Field('CreditHold', '', [], false, 'checkbox', {}, {isClearable: true}),
            archived: new Field('archived', '', [''], false, 'checkbox'),
            limit: new Field('limit', DEFAULT_QUERY_LIMIT, [''], false, 'select', {hideLabel: true}, {menuPlacement: "top"}),
        }
    }

    getFields = () => {
        return {
            LegalName: new Field('LegalName', '', ['empty'], false, 'custom', {
                render: (item) => {
                    return (
                        <span
                            className={`cursor-pointer font-semibold' ${item.CreditHold ? 'text-red-600' : ''} cursor-pointer`}
                        >
                            {`${item.LegalName}`}
                        </span>
                    )
                }
            }),
            Progress: new Field('Progress', '', [''], false, 'custom', {
                label: "Progress",
                render: (it) => <CandidateChecklistProgress item={it}/>,
            }),

            Reminders: new Field('Reminders', '', [''], false, 'custom', {
                label: "Reminder",
                render: (it) => (
                    <ReminderCell
                        reminders={it.Reminders}
                        onSetReminderClick={() => this.handleSetReminderClick(it)}
                    />
                )
            }),
            DBAName: new Field('DBAName', '', ['empty']),
            USDOTNumber: new Field('USDOTNumber', '', ['empty']),
            MCNumber: new Field('MCNumber', '', ['empty'], false, 'custom', {
                label: "MCMXNumber",
                render: (it) => <CellButtonWithCopy copyText={it.MCNumber} translate={this.props.translate}>
                    {it.MCNumber}
                </CellButtonWithCopy>
            }),
            FFNumber: new Field('FFNumber', '', ['empty'], false, 'custom', {
                render: (it) => <CellButtonWithCopy copyText={it.FFNumber} translate={this.props.translate}>
                    {it.FFNumber}
                </CellButtonWithCopy>
            }),
            SCAC: new Field('SCAC', '', ['empty']),
            FederalID: new Field('FederalID', '', ['empty']),
            AddressName: new Field('AddressName', '', ['empty']),
            CityName: new Field('CityName', '', ['empty']),
            State: new Field('State', '', ['empty']),
            Country: new Field('Country', '', []),
            OfficeID: new Field('OfficeID', '', [''], false, 'select-search'),
            ContactGroupID: new Field('ContactGroupID', '', [''], false, 'select-search'),

            CreateUpdateDate: new Field('CreateUpdateDate', '', [], false, 'date')
        }
    }

    saveFilters = () => {
        let filters = []
        Object.keys(this.getQuery()).map(it => filters.push(it))
        LocalStorage.persistState(this.pagePath, this.state, filters)
    }

    getResource = () => {
        return Resources.Customers
    }

    getPrimaryKey = () => {
        return 'CustomerID'
    }

    toggleCreateSuccessDialog = () => {
        this.setState({
            isCreateSuccessDialogOpen: !this.state.isCreateSuccessDialogOpen
        })
    }

    /** Reminder
     ================================================================= */
    handleSetReminderClick = (item) => {
        this.setState({
            reminderItem: item,
            isReminderModalOpen: true,
        });
    }

    handleReminderInputChange = (fields, name, value) => {
        const updatedFields = FieldsManager.updateField(fields, name, value);

        if (name === 'IsAllDay') {
            updatedFields.ReminderTime.type = value ? 'hidden' : 'time-custom-new';
            updatedFields.ReminderDate.metadata.addContainerClass = value ? 'col-span-full' : undefined;
        }

        return updatedFields;
    }

    handleReminderIsDoneChange = (reminder, value) => {
        this.setState(prev => ({
            reminderItem: {
                ...prev.reminderItem,
                Reminders: prev.reminderItem.Reminders.map(r =>
                    r.ChecklistReminderID === reminder.ChecklistReminderID
                        ? {...r, IsDone: value ? 1 : 0}
                        : r
                ),
            }
        }));

        this.props.dispatch(updateResource({
            user: LocalStorage.get('user'),
            params: {
                id: reminder.ChecklistReminderID,
                IsDone: value ? 1 : 0,
            },
            query: this.getQuery(),
            errorMessage: true,
            resource: Resources.CustomersReminder,
            piggyResource: Resources.Customers,
        }));
    }

    handleConfirmReminderDeleteClick = () => {
        this.props.dispatch(deleteResource({
            user: LocalStorage.get('user'),
            query: {id: this.state.reminderDeleteItem.ChecklistReminderID},
            errorMessage: true,
            successMessage: this.props.translate('message.reminder_deleted'),
            resource: Resources.CustomersReminder,
            piggyResource: Resources.Customers,
            piggyQuery: this.getQuery(),
        }));

        this.setState(prev => ({
            reminderItem: {
                ...prev.reminderItem,
                Reminders: prev.reminderItem.Reminders.filter(r => r.ChecklistReminderID !== prev.reminderDeleteItem.ChecklistReminderID),
            },
            reminderDeleteItem: null,
        }));
    }

    handleReminderEditSubmit = (reminder, fields) => {
        const params = FieldsManager.getFieldKeyValues(fields);

        if (!params.IsAllDay) {
            const time = params.ReminderTime || '00:00:00';
            params.ReminderDate = params.ReminderDate.split(' ')[0] + ' ' + time;
        }

        params.ReminderDate = timeZoneToUTC(params.ReminderDate);
        params.ChecklistReminderID = reminder.ChecklistReminderID;

        this.setState({isReminderEditSaving: true});

        this.props.dispatch(updateResource({
            user: LocalStorage.get('user'),
            params,
            query: this.getQuery(),
            errorMessage: true,
            successMessage: this.props.translate('message.reminder_updated'),
            resource: Resources.CustomersReminder,
            piggyResource: Resources.Customers,
            onPiggyCallback: (res) => {
                this.setState({isReminderEditSaving: false});
                const updated = res?.data?.list?.find(r => r.CustomerID === this.state.reminderItem?.CustomerID);
                if (updated) {
                    this.setState(prev => ({
                        reminderItem: {...prev.reminderItem, Reminders: updated.Reminders}
                    }));
                }
            },
        }));
    }

    handleReminderSubmitClick = (params) => {
        if (!params) return;

        params.CustomerID = this.state.reminderItem.CustomerID;

        if (!params.IsAllDay) {
            const time = params.ReminderTime || '00:00:00';
            params.ReminderDate = params.ReminderDate.split(' ')[0] + ' ' + time;
        }

        params.ReminderDate = timeZoneToUTC(params.ReminderDate);

        this.setState({isReminderSaving: true});

        this.props.dispatch(createResource({
            user: LocalStorage.get('user'),
            params,
            query: this.getQuery(),
            errorMessage: true,
            successMessage: `Reminder for ${this.state.reminderItem.LegalName} saved`,
            resource: Resources.CustomersReminder,
            piggyResource: Resources.Customers,
            onPiggyCallback: () => {
                this.setState({
                    isReminderSaving: false,
                    isReminderModalOpen: false,
                    reminderItem: null,
                });
            },
        }));
    }

    getReminderFields = (data = {}) => {
        const normalizedData = data?.ReminderDate
            ? {...data, ReminderDate: toFrontDateTimeFromUTC(data.ReminderDate)}
            : data;

        const fieldTemplates = {
            IsAllDay: new Field('IsAllDay', '', [], false, 'checkbox', {
                addContainerClass: "col-span-full",
                labelType: "float",
                label: "IsAllDayReminder"
            }, {}),
            ReminderDate: new Field('ReminderDate', '', ['empty'], false, 'date', {addContainerClass: data?.IsAllDay ? "col-span-full" : undefined}, {isClearable: true}),
            ReminderTime: new Field('ReminderTime', '', [], false, data?.IsAllDay ? 'hidden' : 'time-custom-new', {withDateField: "ReminderDate"}, {isClearable: true}),
            Notes: new Field("Notes", '', [], false, 'textarea', {
                Label: "ReminderNotes",
                addContainerClass: "col-span-full"
            })
        }

        return fillFieldsFromData(fieldTemplates, normalizedData);
    }

    /** Render
     ================================================================= */
    render() {
        const {translate, resource} = this.props
        const data = getProp(resource.data, 'list', [])
        const count = getProp(resource.data, 'count', 0)
        const isLoading = !!resource.isLoading;

        return (
            <Layout
                onBreakpointChange={this.handleBreakpointChange}
                isAccessible={!(resource.errorStatus === 2)}
                {...this.props}
            >
                <Page>
                    <PageHeader
                        title={translate('page.heading.customers')}
                        buttonLabel={translate('btn.create_new')}
                        hasPerm={checkPerm(this.getResource(), CREATE_PERM)}
                        onButtonClick={() => this.handleCreateUpdateResource()}
                        afterTitle={(
                            <PageHeaderInfo
                                dispatch={this.props.dispatch}
                            />

                        )}
                    >
                        {!CompanyExceptions('CarriersImportFMCSADisabled', false) && (
                            <Button
                                hasPerm={checkPerm(Resources.Customers, CREATE_PERM)}
                                onClick={this.handleImportFMCSAClick}
                            >
                                {translate("btn.import_from_FMCSA")}
                            </Button>
                        )}
                    </PageHeader>

                    <div className="sm:flex">
                        <ActiveFilters
                            filterFields={this.state.queryFilterFields}
                            onLabelClick={this.handleFilterInputChange}
                            onClearFiltersClick={this.handleClearFiltersClick}
                            translate={translate}
                        />

                        <div className="ml-auto flex sm:justify-start justify-end items-center">
                            {/*<Tippy content={translate('text.download_template')}>
                                <button
                                    className="btn-icon"
                                    onClick={this.downloadExcelTemplate}
                                >
                                    <RectangleGroupIcon className="w-5 h-5"/>
                                </button>
                            </Tippy>*/}

                            <Tippy content={translate('text.download_excel')}>
                                <button
                                    className="btn-icon"
                                    onClick={this.downloadExcel}
                                >
                                    <DocumentArrowDownIcon className="w-5 h-5"/>
                                </button>
                            </Tippy>

                            <TableSettingsPopOver
                                options={this.state.tableOptions}
                                setOptions={this.setOptions}
                                toggleColumnSettingsDialog={this.handleToggleColumnSettingsDialog}
                                translate={translate}
                            />
                        </div>
                    </div>

                    <TableCard
                        addClass={
                            classNames(
                                this.state.isTableFullScreen
                                    ? "fixed inset-1 -top-1 z-50"
                                    : undefined
                            )}
                    >
                        <TableFilters
                            hideLimit
                            filterFields={this.state.queryFilterFields}
                            handleInputChange={this.handleFilterInputChange}
                            translate={translate}
                            onRefreshTable={this.fetchData}
                            onFullScreenToggle={this.handleFullScreenToggle}
                            isTableFullScreen={this.state.isTableFullScreen}
                            isLoading={isLoading}
                        />

                        <ResourceTable
                            data={data}
                            fields={this.getFields()}
                            verticalTableIsVisible={this.state.breakpoint.index <= 1}

                            translate={translate}
                            isLoading={resource.isLoading}

                            options={this.state.tableOptions}

                            limit={this.state.queryFilterFields.limit.value}

                            sort={this.state.sort}
                            sortBy={this.state.sortBy}
                            onSortChange={this.handleUpdateSort}
                            saveTableOptions={this.setOptions}

                            onRowClick={checkPerm(this.getResource(), UPDATE_PERM) ? this.handleCreateUpdateResource : null}

                            onView={this.handleShowDetails}
                            onEdit={this.handleCreateUpdateResource}
                            onDelete={this.archiveResource}
                            onRestore={this.restoreFromArchive}

                            hasViewPerm={checkPerm(Resources.OrganizationsQuick, READ_PERM)}
                            hasEditPerm={checkPerm(Resources.CustomersInfo, UPDATE_PERM)}
                            hasDeletePerm={checkPerm(this.getResource(), DELETE_PERM)}
                            hasRestorePerm={checkPerm(this.getResource(), UPDATE_PERM)}

                            tableKey={this.getPrimaryKey()}
                        />

                        {/*Table footer*/}
                        <TableCardFooter
                            show={!(!data.length && !resource.isLoading)}
                        >

                            <Pagination
                                count={count}
                                isLoading={resource.isLoading}
                                hideRowsPerPage={this.state.breakpoint.index <= 1}
                                handleQueryChange={
                                    (name, value, currentPage) => name === "offset"
                                        ? this.handleUpdateOffset(value, currentPage)
                                        : this.handleFilterInputChange(name, value)
                                }
                                pageOffset={this.state.offset}
                                queryFields={this.state.queryFilterFields}
                                translate={translate}
                            />
                        </TableCardFooter>


                        <NoRecordsTable
                            show={(data.length === 0) && !resource.isLoading}
                            canCreate={checkPerm(this.getResource(), CREATE_PERM)}
                            title={translate('text.no_matching_records')}
                            text={translate('text.create_new_resource', [this.state.queryFilterFields.query.value])}
                            btnLabel={translate('btn.create_customer')}
                            onBtnClick={() => {
                                this.setState({prefilled: this.state.queryFilterFields.query.value}, () => {
                                    this.handleCreateUpdateResource()
                                })
                            }}
                            onClearFilterClick={this.handleClearFiltersClick}
                            clearFilterBtnLabel={translate('text.clear_all_filters')}
                            clearFilterText={translate('text.try_without_filters')}
                            filters={this.state.queryFilterFields}
                        />
                    </TableCard>

                    <ModalConfirm
                        title={'Confirm'}
                        show={!!this.state.confirmDialog}
                        text={this.state.text}
                        onClose={() => this.setState({confirmDialog: false})}
                        buttonLabel={translate('btn.confirm')}
                        closeButtonLabel={'Cancel'}
                        translate={translate}
                        onConfirm={this.state.confirmModal}
                    />

                    <TableOptionsDialog
                        show={this.state.isColumnsDialogVisible}
                        pagePath={this.pagePath}
                        columns={this.state.tableOptions.columns}
                        setTableColumnOptions={this.handleSetTableColumnOptions}
                        getDefaultTableColumnOptions={this.getDefaultTableColumnOptions}
                        onClose={this.handleToggleColumnSettingsDialog}
                        translate={translate}
                    />

                    <FmcsaImportDialog
                        show={this.state.isImportFMCSADialogVisible}
                        translate={translate}
                        dialogResource={this.props.dialogResource}
                        onClose={this.handleCloseImportFMCSAClick}
                        importButtonLabel={translate("btn.import_customer")}
                        onImportCarrierClick={this.importFromFMCSA}
                        isCustomerImport={true}
                    />

                    <ModalSaveResource
                        widthClass="max-w-sm"
                        title={translate('modal_heading.reminders_customer', [this.state.reminderItem?.LegalName])}
                        show={this.state.isReminderModalOpen}
                        isLoading={this.state.isReminderSaving || resource.isLoading}
                        onClose={() => this.setState({isReminderModalOpen: false, reminderItem: null})}
                        handleInputChange={this.handleReminderInputChange}
                        gridColsClass="grid-cols-2"
                        fields={this.getReminderFields()}
                        buttonLabel={translate('btn.add_reminder')}
                        closeButtonLabel={translate('btn.cancel')}
                        translate={translate}
                        onSubmit={this.handleReminderSubmitClick}
                        htmlBefore={<ReminderList
                            reminders={this.state.reminderItem?.Reminders}
                            translate={translate}
                            isLoading={this.state.isReminderEditSaving}
                            onIsDoneChange={this.handleReminderIsDoneChange}
                            onDelete={(reminder) => this.setState({reminderDeleteItem: reminder})}
                            getEditFields={this.getReminderFields}
                            onEditInputChange={this.handleReminderInputChange}
                            onEditSubmit={this.handleReminderEditSubmit}
                            reminderIdKey="ChecklistReminderID"
                        />}
                    />

                    <ModalConfirm
                        type="danger"
                        title={translate('modal_heading.delete_reminder')}
                        show={!!this.state.reminderDeleteItem}
                        text={translate('text.confirm_delete_reminder', [toFrontDateTimeFromUTC(this.state.reminderDeleteItem?.ReminderDate)])}
                        buttonLabel={translate('btn.delete')}
                        closeButtonLabel={translate('btn.cancel')}
                        translate={translate}
                        onClose={() => this.setState({reminderDeleteItem: null})}
                        onConfirm={this.handleConfirmReminderDeleteClick}
                    />

                    <Modal
                        show={this.state.isCreateSuccessDialogOpen}
                        widthClass={'max-w-sm w-screen'}
                        onClose={this.toggleCreateSuccessDialog}
                    >
                        <ModalHeader
                            title={translate("text.customer_imported_successfully")}
                            onClose={this.toggleCreateSuccessDialog}
                        />
                        <CreateSuccessModal
                            translate={translate}
                            buttons={[
                                {
                                    label: translate("btn.view_imported_customer"),
                                    onClick: () => this.props.history.push(
                                        "/customers/info/" + this.OrganizationID + "/" + this.importedCustomerID
                                    ),
                                    iconLeading: DocumentTextIcon,
                                },
                                {
                                    label: translate("btn.list"),
                                    onClick: () => {
                                        this.fetchData();
                                        this.toggleCreateSuccessDialog();
                                    },
                                    iconLeading: Bars4Icon,
                                    iconTrailing: ArrowTopRightOnSquareIcon
                                },
                                {
                                    label: translate("btn.dashboard"),
                                    onClick: () => this.props.history.push("/home"),
                                    iconLeading: PresentationChartBarIcon,
                                    iconTrailing: ArrowTopRightOnSquareIcon
                                },
                            ]}
                        />
                    </Modal>
                </Page>
            </Layout>
        )
    }
}

export default connect(state => state)(Customers)
